import { privateAxios } from '../requestsCollection';
import { IResponse } from '../types';
import {
  IArchivedMedicaidPlan,
  IMedicaidPlan,
  IMedicaidPlanArchiveRequest,
  IMedicaidPlanClient,
  IMedicaidPlanCreateRequest,
  IMedicaidPlanUpdateRequest,
} from './types';

const medicaidPlanUrl = ({ clinicId, clientId }: IMedicaidPlanClient): string =>
  `clinic/${clinicId}/client/${clientId}/medicaid-plan`;

export const getMedicaidPlan = (
  requestInfo: IMedicaidPlanClient,
): IResponse<IMedicaidPlan | null> =>
  privateAxios({ method: 'get', url: medicaidPlanUrl(requestInfo) });

export const createMedicaidPlan = (
  requestInfo: IMedicaidPlanClient,
  data: IMedicaidPlanCreateRequest,
): IResponse<IMedicaidPlan> =>
  privateAxios({ method: 'post', url: medicaidPlanUrl(requestInfo), data });

export const updateMedicaidPlan = (
  requestInfo: IMedicaidPlanClient,
  data: IMedicaidPlanUpdateRequest,
): IResponse<IMedicaidPlan> =>
  privateAxios({ method: 'put', url: medicaidPlanUrl(requestInfo), data });

export const archiveMedicaidPlan = (
  requestInfo: IMedicaidPlanClient,
  data: IMedicaidPlanArchiveRequest,
): IResponse<IArchivedMedicaidPlan> =>
  privateAxios({ method: 'post', url: `${medicaidPlanUrl(requestInfo)}/archive`, data }, 'v1/');

export const getMedicaidPlanHistory = (
  requestInfo: IMedicaidPlanClient,
): IResponse<IArchivedMedicaidPlan[]> =>
  privateAxios({ method: 'get', url: `${medicaidPlanUrl(requestInfo)}/history` }, 'v1/');
